import React from "react";

export default function FieldBlock({
  label,
  value,
  color,
  wrap = false,
  align = "left",
  labelSize = 10,
  valueSize = 12.5,
  valueWeight = 600,
}) {
  return (
    <div style={{ minWidth: wrap ? 0 : undefined, textAlign: align }}>
      <div style={{ fontSize: labelSize, fontWeight: 700, letterSpacing: "0.04em", color: "#c3c8cc", marginBottom: 3 }}>
        {label}
      </div>
      <div
        style={{
          fontSize: valueSize,
          fontWeight: valueWeight,
          color: color || "#c3c8cc",
          overflow: "hidden",
          textOverflow: wrap ? undefined : "ellipsis",
          whiteSpace: wrap ? undefined : "nowrap",
          overflowWrap: wrap ? "anywhere" : undefined,
          wordBreak: wrap ? "break-word" : undefined,
          lineHeight: wrap ? 1.25 : undefined,
        }}
      >
        {value}
      </div>
    </div>
  );
}
